<script>
  import Container from './layout/container.svelte';
  import { location } from 'svelte-spa-router';

  export let force = false;

  let lastModified = document.lastModified;
</script>

{#if force || $location === '/' || Number($location.split('/')[1]) === 1}
  <!-- Aqui devemos colocar toda a lógica do Header, que altera conforme a página atual -->
  <!-- No momento, apenas exibindo a imagem -->
  <div class="container" style="max-width: 40em !important;">
    <div>
      <h1>Cardápio SENAD</h1>
      <p>Atualizado em: {lastModified}</p>
    </div>
  </div>
{/if}

<style>
  h1 {
    font-size: 28px;
    font-weight: 400;
    padding: 0;
    margin: 0;
    display: inline;
  }

  .container > div {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    column-gap: 20px;
    /* justify-content: space-evenly; */
  }

  .container {
    display: none;
  }

  p {
    display: inline;
    padding: 0;
    margin: 0;
    font-size: 14px;
    background: #fef4dc55;
  }

  @media (max-width: 767px) {
    .img-wrapper {
      max-height: 200px;
    }

    img {
      width: unset;
      object-fit: none;
      object-position: -80vw;
    }

    .container {
      padding: 0;
    }
  }
</style>
